// extracted by mini-css-extract-plugin
export default {"Circle5":"Circle5_Circle5__rW9au"};